import gql from 'graphql-tag';
import apollo from 'src/features/apollo';

const query = gql`
query AvgVotesForChannel($channelType: String!) {
  avgVoteByRequestTypeForChannel(channelType: $channelType) {
     id,
     name,
     avgVote
  }
}`;

function getAvgIndicativeVotesForChannel(channelType) {
  return apollo.client.query({
    query,
    variables: {
      channelType,
    },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.avgVoteByRequestTypeForChannel);
}

export default getAvgIndicativeVotesForChannel;
